import { get } from 'react-hook-form';
import type { FieldErrors, FieldValues, Path, UseFormRegister } from 'react-hook-form';

import type { JSX } from 'react';

/**
 * セレクトボックス基本コンポーネント
 */
export default function FormSelect<TFieldValues extends FieldValues = FieldValues>(props: {
  // タイトル
  subject?: string;
  // name属性
  name: string;
  // ブランク行の有無
  blank?: boolean;
  // ブランク行のラベル
  blankLabel?: string;
  // 選択オプション配列
  options: { value: string | number; label: string }[];
  // 必須検証の有無
  required?: boolean;
  // 必須/任意のアイコン表示有無
  requiredMark?: boolean;
  // 無効化
  disabled?: boolean;
  errors: FieldErrors<TFieldValues>;
  // クラス名
  className?: string;

  register: UseFormRegister<TFieldValues>;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  // 検証タイプの取得
  const type = get(props.errors, props.name)?.type ?? null;

  return (
    <>
      {props.subject && (
        <label className="form-label">
          {props.subject}
          {props.requiredMark && (
            <span className={props.required ? 'must' : 'any'}>{props.required ? ' *' : ''}</span>
          )}
        </label>
      )}
      <select
        className={
          get(props.errors, props.name)
            ? `form-select form-control is-invalid ${props.className}`
            : `form-select form-control ${props.className}`
        }
        name={props.name}
        disabled={props.disabled ? true : false}
        {...props.register(props.name as Path<TFieldValues>, {
          required: props.required,
        })}
      >
        {props.blank && (
          <option key={props.subject} value="">
            {props.blankLabel}
          </option>
        )}
        {props.options.map(item => {
          return (
            <option key={item.label} value={item.value}>
              {item.label}
            </option>
          );
        })}
      </select>
      {get(props.errors, props.name) && (
        <p className="error">
          {type === 'required' && <>必須項目です。</>}
          {type === 'custom' && <>{get(props.errors, props.name)?.message}</>}
        </p>
      )}
    </>
  );
}
